var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14,0C6.27,0,0,6.27,0,14s6.27,14,14,14,14-6.27,14-14S21.73,0,14,0Z",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.44,10.91c-.04-.79-.16-1.34-.35-1.82-.19-.49-.45-.91-.87-1.32-.41-.42-.83-.68-1.32-.87-.48-.18-1.02-.31-1.82-.35-.8-.03-1.06-.05-3.09-.05s-2.29.01-3.09.05c-.79.04-1.34.16-1.82.35-.49.19-.91.45-1.33.87-.41.41-.67.83-.86,1.32-.18.48-.31,1.02-.35,1.82-.03.8-.05,1.06-.05,3.09s.01,2.29.05,3.09c.03.79.16,1.34.35,1.82.19.49.45.91.86,1.33.42.41.83.67,1.33.86.48.18,1.02.31,1.82.35.8.03,1.06.05,3.09.05s2.29-.01,3.09-.05c.79-.03,1.34-.16,1.82-.35.49-.19.91-.45,1.32-.86.42-.42.68-.83.87-1.33.18-.48.31-1.02.35-1.82.03-.8.05-1.06.05-3.09s-.01-2.29-.05-3.09ZM20.09,17.02c-.03.73-.15,1.12-.26,1.39-.14.35-.3.6-.56.86-.26.26-.51.42-.86.56-.27.1-.66.23-1.39.26-.79.03-1.03.04-3.02.04s-2.24,0-3.02-.04c-.73-.03-1.12-.16-1.39-.26-.35-.14-.6-.3-.86-.56s-.43-.52-.56-.86c-.1-.27-.23-.66-.26-1.39-.03-.79-.04-1.03-.04-3.02s0-2.24.04-3.02c.03-.73.16-1.12.26-1.39.14-.35.3-.6.56-.86.26-.27.51-.43.86-.56.27-.1.66-.23,1.39-.26.79-.04,1.03-.05,3.02-.05s2.24,0,3.02.05c.73.03,1.12.15,1.39.26.35.14.6.3.86.56.27.26.43.51.56.86.1.27.23.66.26,1.39.04.79.05,1.03.05,3.02s0,2.24-.05,3.02Z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18,9.11c-.49,0-.9.4-.9.9s.4.9.9.9.9-.4.9-.9-.4-.9-.9-.9Z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14,10.16c-2.12,0-3.84,1.72-3.84,3.84s1.72,3.84,3.84,3.84,3.84-1.72,3.84-3.84-1.72-3.84-3.84-3.84ZM14,16.5c-1.38,0-2.5-1.12-2.5-2.5s1.12-2.5,2.5-2.5,2.5,1.12,2.5,2.5-1.12,2.5-2.5,2.5Z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.2d59cf1033afd5a824d729e49a2cf24b.svg";
export { ForwardRef as ReactComponent };